import React, { useState } from 'react'
import Button from 'components/button'
import Input from 'components/input'
import { isValidEmail } from 'helpers/utils'

export interface IFormValues {
  email: string
}

interface Props {
  onSubmit: (values: IFormValues) => void
}

const SendPasswordResetForm: React.FC<Props> = ({ onSubmit }) => {
  const [submitting, setSubmitting] = useState<boolean>(false)
  const [values, setValues] = useState<IFormValues>({
    email: ''
  })

  const emailError = !isValidEmail(values.email) && values.email !== ''
  const handleSubmit = async () => {
    setSubmitting(true)
    await onSubmit(values)
    setSubmitting(false)
  }

  return (
    <div className="w-full">
      <Input
        name="email"
        type="text"
        placeholder="Your email address"
        onChange={(event) => setValues({ ...values, email: event.target.value })}
      />
      {emailError && <p className="text-red mt-2.5">This must be a valid email address</p>}
      <Button
        className="mt-5 w-full text-[1rem]"
        onClick={() => handleSubmit()}
        disabled={emailError}
        isLoading={submitting}
      >
        Reset Password
      </Button>
    </div>
  )
}

export default SendPasswordResetForm
